import { render, staticRenderFns } from "./SubmitAgreement.vue?vue&type=template&id=a36ae33c&scoped=true"
import script from "./SubmitAgreement.vue?vue&type=script&lang=js"
export * from "./SubmitAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36ae33c",
  null
  
)

export default component.exports